import { render, staticRenderFns } from "./NewGroupDialog.vue?vue&type=template&id=43d2a3ba&scoped=true&"
import script from "./NewGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./NewGroupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewGroupDialog.vue?vue&type=style&index=0&id=43d2a3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2a3ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
